import onResize from '../utils/onResize';

const register = [];

function wrap(table) {
    const outer = document.createElement('div');
    outer.classList.add('responsive-table');

    const inner = document.createElement('div');
    inner.classList.add('responsive-table-inner');

    outer.appendChild(inner);

    table.parentNode.insertBefore(outer, table);
    inner.appendChild(table);

    return outer;
}

function markActive({ table, outer }) {
    const fn = table.offsetWidth > outer.offsetWidth ? 'add' : 'remove';
    outer.classList[fn]('responsive-table--active');
}

function markTablesActive() {
    register.forEach(markActive);
}

function setupTables(tables) {
    tables.forEach(table => {
        const outer = wrap(table);
        register.push({ table, outer });
    });
}

export default function init(tables) {
    setupTables(tables);
    markTablesActive();
    onResize(markTablesActive);
}
